import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export const SectionWrapper = ({ classProps, children }: PropsWithChildren & PropsWithClassProps) => {
  return <div className={twMerge('mx-auto max-w-md', classProps?.root)}>{children}</div>;
};
